export default __webpack_public_path__ + "static/media/goldClass.a40d4694.png";